// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"dc9cc3e9","455":"aae2a572","977":"fe02a2b2"}[chunkId] + ".chunk.js";
};